import React from 'react';
import Checkbox, { CheckboxInputProps } from 'Elements/Input/Checkbox';

import type { ActiveFilter, FilterGroup, HandleFilter } from '.';

import { CheckboxListItem } from './useFilters.styled';

export const generateDropdownOptionsRenderer = (
    filter: FilterGroup,
    activeFilters: ActiveFilter[],
    handleFilter: HandleFilter
): React.JSX.Element[] =>
    filter.options.map(item => {
        const activeFilter = activeFilters.find(({ id }) => id === item.id);
        return (
            <React.Fragment key={`filter-${item.id}`}>
                <Checkbox
                    defaultChecked={!!activeFilter}
                    onChange={() =>
                        handleFilter(activeFilter ? true : false, item.id, filter.type, item.label)
                    }
                    {...item}
                />
            </React.Fragment>
        );
    });

export const generateCheckboxOptionsRenderer = (
    filter: CheckboxInputProps[],
    type: string,
    activeFilters: ActiveFilter[],
    handleFilter: HandleFilter
): React.JSX.Element[] =>
    filter.map(item => {
        const activeFilter = activeFilters.find(({ id }) => id === item.id);
        return (
            <CheckboxListItem key={item.id}>
                <Checkbox
                    {...item}
                    defaultChecked={activeFilter ? true : false}
                    onChange={() =>
                        handleFilter(activeFilter ? true : false, item.id, type, item.label)
                    }
                />
            </CheckboxListItem>
        );
    });
